import styled, { css } from 'styled-components';
import { List, RowDiv, theme } from 'styles';
import { NavLink } from 'react-router-dom';

const common = css`
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  transition: 150ms ease;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.gray100};
  }

  &:focus-visible:not(:disabled) {
    box-shadow: inset 0 0 0 1px ${theme.colors.gray100};
  }

  &:active {
    background-color: ${theme.colors.gray200};
  }
`;

export const SideWrap = styled.div`
  position: fixed;
  display: flex;
  min-width: 360px; // 2024-10-02 변경
  max-width: 360px; // 2024-10-02 변경
  z-index: 10;
  height: 100vh;
  padding-bottom: 40px;
  border-right: 1px solid ${theme.colors.gray50};
`;

export const Nav = styled.nav`
  width: 120px; // 2024-10-02 변경
  padding: 40px 8px; // 2024-10-02 변경
  height: 100vh;
  background-color: ${theme.colors.gray50};

  .logoBox {
    width: fit-content;
    margin: auto;
  }

  & > ul {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

export const MenuLink = styled(NavLink)`
  width: 100%; // 2024-10-02 변경
  padding: 6px 4px; // 2024-10-02 변경
  border-radius: 8px;
  background-color: ${({ $active }) => ($active ? theme.colors.primary50 : 'transparent')};
  box-shadow: ${({ $active }) => ($active ? 'inset 1px 1px 4px 0px rgba(40, 191, 194, 0.2)' : 'none')};
  transition: background-color 150ms ease;

  &:hover,
  &:focus-visible:not(:disabled) {
    .box {
      background-color: ${({ $active }) => (!$active ? theme.colors.fill12 : 'transparent')};
    }
  }
`;

export const IconDiv = styled.div`
  width: 28px;
  height: 28px;
  padding: 2px;
  margin: auto;
  border-radius: 8px;
  transition: background-color 150ms ease;
`;

export const SubBox = styled.div`
  flex: 1;
  padding: 44px 12px;
  background-color: white;
  overflow: hidden;
  max-height : 100%;
  overflow-y : auto;

  /* 스크롤바 스타일 */
  -ms-overflow-style: none; /* IE에서 기본 스크롤 스타일 제거 */

  &::-webkit-scrollbar {
    width: 4px; /* 스크롤바 너비를 6px로 설정 */
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray400}; /* 스크롤바 색상 */
    border-radius: 4px; /* 스크롤바의 둥근 모서리 */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.gray400}; /* 호버 시 스크롤바 색상 */
  }

  &::-webkit-scrollbar-track {
    background: ${theme.colors.gray100}; /* 스크롤바 트랙 배경색 */
  }
`;

export const LabelDiv = styled(RowDiv)`
  display: flex;
  align-items: center;
  padding: 16px 0;
  gap: 8px;
  
`;

export const Dep2Div = styled.div`
  ${common}
  padding: 12.5px 8px;
  
`;

export const Dep3Link = styled(NavLink)`
  ${common}
  padding: 16px 8px 16px 16px;
`;

export const Dep4Link = styled(NavLink)`
  ${common}
  padding: 12px 16px 12px 32px;
  background-color: ${({ $active }) => ($active ? theme.colors.primary100 : 'transparent')};
`;

export const ScrollList = styled(List)`
  max-height: calc(100vh - 400px);
  overflow-y: auto;
`;
